import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonModule, ButtonOptions } from '@usitsdasdesign/dds-ng/button';
import { CardModule, CardOptions } from '@usitsdasdesign/dds-ng/cards';
import { ButtonKind, ExtThemes, Size, WidthState } from '@usitsdasdesign/dds-ng/shared';
import { ProjectsService } from '../core/services/projects.service';
import { Project } from '../core/models/project.models';

@Component({
  selector: 'app-projects',
  standalone: true,
  imports: [
    ButtonModule,
    CardModule,
  ],
  templateUrl: './projects.component.html',
  styleUrl: './projects.component.scss'
})
export class ProjectsComponent {
  constructor(
    private router: Router,
    private projectService: ProjectsService,
  ) { }

  createButtonOptions: ButtonOptions = {
    theme: ExtThemes.green,
    kind: ButtonKind.primaryLoud,
    size: Size.md,
    width: WidthState.fixed,
    isLoading: false,
    icon: 'dds-icon_plus',
    isIconLeft: false,
    isColorBg: false,
    isInverse: false,
    disabled: false,
    ariaLabel: 'Create project',
    customClass: '',
    role: 'button'
  }

  createProjectClick(event: Event): void {
    this.router.navigate(['project-create']);
  }

  viewButtonOptions: ButtonOptions = {
    theme: ExtThemes.blue,
    kind: ButtonKind.primaryLoud,
    size: Size.md,
    width: WidthState.fixed,
    isLoading: false,
    icon: '',
    isIconLeft: true,
    isColorBg: false,
    isInverse: false,
    disabled: false,
    ariaLabel: 'View',
    customClass: '',
    role: 'button'
  }

  viewProjectClick(id: string): void {
    this.router.navigate(['project-details', id]);
  }

  cardOptions: CardOptions = {
    size: Size.md,
    isVertical: false,
    isSelectable: false,
    isClickable: false,
    isUnbordered: false,
    isInverse: false,
    customClass: '',
    isWrapFocusDisabled: true,
  };

  projects: Project[];
  hasProjects: boolean = true;

  ngOnInit(): void {
    this.projects = [];
    this.projectService.getProjects().subscribe(response => {
      this.projects = response;
      this.hasProjects = this.projects.length > 0;
    });
  }

}
